<template>
  <DataListStateful
    title="Торговые марки"
    resource="trademarks"
    store="trademarks"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "Производитель",
          name: "manufacturer",
          dataPath: "Manufacturer.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        manufacturer: {
          title: "Производитель",
          type: "reference",
          resource: "manufacturers",
        },
      },
    };
  },
};
</script>
